import React, { useState, useEffect } from "react";
import "../../style/common/header.scss";
import MobileNav from "./MobileNav";
import unbxdNetworkLogo from '../../new-netcore-unbxd-dark-logo.svg';

const Header = () => {
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [navPosition, setNavPosition] = useState("");
    let prevScrollpos;

    const toggleHeaderNav = () => {
        setIsNavOpen(!isNavOpen);
    };

    const onWindowScroll = () => {
        if (typeof (window) !== "undefined") {
            const currentScrollPos = window.pageYOffset;
            if ((currentScrollPos < 85) || (prevScrollpos > currentScrollPos)) {
                setNavPosition("visible");
            } else {
                setNavPosition("hiding");
            }
            prevScrollpos = currentScrollPos;
        }
    }

    useEffect(() => {
        prevScrollpos = window.pageYOffset;
        window.addEventListener("scroll", onWindowScroll);

        return () => {
            window.removeEventListener("scroll", onWindowScroll);
        }
    }, []);


    return (
        <header className={`page-header ${navPosition} ${isNavOpen? 'sidebar-open' : ''}`}>
            <div className="container">
                <nav className="navbar">
                    <section className="navbar-section unbxd-logo-wrapper">
                        <a href="/" className="unbxd-logo">
                            <img src={unbxdNetworkLogo} alt="unbxd logo" />
                        </a>
                    </section>
                    <div className="center-heading hide-md">Power Your Search With Unbxd AI</div>
                    <section className="hide-xl">
                        <nav className="navbar">
                            <a href="https://unbxd.com/" target="_blank" className="btn login-btn">Visit unbxd.com</a>
                            <a href="https://unbxd.com/demo/" target="_blank" className="btn btn-primary btn-md">Request a demo</a>
                        </nav>
                    </section>
                    <section className="unbxd-mbl-navbar show-xl">
                        <label className={isNavOpen ? 'close-icon' : 'bar-icon'} onClick={toggleHeaderNav}>
                            {isNavOpen ? <span className="hamburger-icon">&#9747;</span> : <span className="hamburger-icon">&#9776;</span>}
                        </label>
                        <MobileNav isNavOpen={isNavOpen} />
                    </section>
                </nav>
            </div>
        </header>
    )
}

export default Header;
